import {Component, OnInit} from '@angular/core';
import {AbstractFieldComponent} from '../../abstract/abstract-field.component';
import {NumberStepInputConfig} from '../../../models/field-config';
import {FormFieldService} from '../../../services/form-field.service';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {TextTransformService} from '../../../services/text-transform.service';

@Component({
  selector: 'app-number-step-input',
  templateUrl: './number-step-input.component.html',
  styleUrls: []
})
export class NumberStepInputComponent extends AbstractFieldComponent implements OnInit {

  readonly: boolean = false;
  readonlyValue: any;

  get numberStepInputConfig(): NumberStepInputConfig {
    return this.fieldConfig.numberStepInputConfig;
  }

  get value(): number {
    return parseInt(this.control.value.replace(' ', ''));
  }

  constructor(public formFieldService: FormFieldService) {
    super(formFieldService);
  }

  ngOnInit() {
    this.initReadonly();
    this.setReadonlyValue();
    this.handleStatusChanges();
  }

  decrement() {
    if (!isNaN(this.value)) {
      this.setValue(this.value - this.numberStepInputConfig.step);
    }
    this.emitInteractiveClick();
  }

  increment() {
    if (!isNaN(this.value)) {
      this.setValue(this.value + this.numberStepInputConfig.step);
    }
    this.emitInteractiveClick();
  }

  private setValue(value: number): void {
    this.control.setValue(value + '');
  }

  private setReadonlyValue(): void {
    if (this.readonly) {
      const rawValue = this.bean[this.fieldConfig.fieldKey];
      if (isNotNullOrUndefined(rawValue)) {
        if (this.fieldConfig.properties && this.fieldConfig.properties.textTransform && this.fieldConfig.properties.textTransform.separatorConfig) {
          this.readonlyValue = TextTransformService.separateValues(rawValue, this.fieldConfig.properties.textTransform.separatorConfig);
        } else {
          this.readonlyValue = rawValue;
        }
      }
    }
  }

  private initReadonly() {
    if (isNotNullOrUndefined(this.fieldConfig.readonly)) {
      this.readonly = this.fieldConfig.readonly;
    }
  }

}
